import CIS_LOCALE from '@locales/ru-RU.json';
import IND_LOCALE from '@locales/en-IN.json';

export const getLanguages = () => {
  return {
    CIS: CIS_LOCALE,
    IND: IND_LOCALE,
  };
};
